<template>
  <div
    @mouseover="showEventsTip"
    @mouseout="mouseOut"
    v-if="isEventShow"
    class="icon icon-pulce icon_danger pl-1 pr-1 event-tip"
  >
    <template v-if="showToolTip">
      <events-tool-tip ref="tooltip" :events="this.eventsArr"></events-tool-tip>
    </template>
  </div>
</template>

<script>
import { eventsConfig, notAlarm, notShow } from '@/events.config.js'
import('@/styles/components/tooltip.less')

export default {
  name: 'EventIcon',
  components: {
    EventsToolTip: () => import('@/components/EventsToolTip')
  },
  props: {
    eventsString: {
      type: String,
      required: false
    },
    showToolTip: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  created() {
    window.addEventListener('wheel', this.mouseOut)
  },
  methods: {
    showEventsTip(e) {
      if (this.$refs.tooltip) {
        let icon = this.$el.getBoundingClientRect()
        let leftPart = document.documentElement.clientWidth - icon.left
        let tooltip = this.$refs.tooltip.$el.children[0]
        tooltip.style.left = ''
        tooltip.style.right = ''
        tooltip.style.top = ''
        tooltip.style.bottom = ''
        tooltip.className = 'tool-tip'
        tooltip.style.display = 'block'
        if (document.documentElement.clientHeight - e.screenY - icon.height < tooltip.clientHeight) {
          tooltip.className = tooltip.className + ' down'
          tooltip.style.bottom = `${document.documentElement.clientHeight - icon.top - 30}px`
        } else {
          tooltip.className = tooltip.className + ' up'
          tooltip.style.top = `${icon.top - 18}px`
        }
        if (leftPart < tooltip.clientWidth) {
          tooltip.className = tooltip.className + ' left'
          tooltip.style.right = `${document.documentElement.clientWidth - icon.left + 10}px`
        } else {
          tooltip.className = tooltip.className + ' right'
          tooltip.style.left = `${icon.left + 40}px`
        }
      }
    },
    mouseOut() {
      if (this.$refs.tooltip) {
        let tooltip = this.$refs.tooltip.$el.children[0]
        tooltip.style.display = 'none'
      }
    }
  },
  computed: {
    isEventShow() {
      return this.count.total > 0
    },
    count() {
      let eventsArr = this.eventsArr
      if (!eventsArr) {
        return {
          total: 0,
          alarms: 0
        }
      }

      let totalEvents = eventsArr.filter(event => {
        return !notShow.includes(event.episodeType)
      })
      let alarmEvents = totalEvents.filter(event => {
        return !notAlarm.includes(event.episodeType)
      })
      return {
        total: totalEvents.length,
        alarms: alarmEvents.length
      }
    },
    eventsArr() {
      let events = this.eventsString ? JSON.parse(this.eventsString) : []
      let res =
        events.length > 0
          ? events.filter(event => {
              if (!Object.hasOwn(eventsConfig, event.episodeType))
                return

              if (!notShow.includes(event.episodeType)) {
                return (
                  eventsConfig[event.episodeType].color === 'warning' ||
                  eventsConfig[event.episodeType].color === 'danger'
                )
              }
            })
          : []
      return res
    }
  }
}
</script>
